import { Fragment } from 'react';

import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { MembersCard, PartyContextProvider } from 'src/containers/Escrow/Summary';

import { BasicsCard, PartyCard, TechnicalSettingsCard, AgreementSettingsCard } from './ui';

const Members = () => {
  const {
    softwareEscrow: { id, currentCompanyRole },
    softwareEscrow: { [currentCompanyRole as EscrowPartyTypeEnum]: party },
  } = useSoftwareEscrow();

  return <MembersCard escrowId={id} escrowPartyId={party!.id} basePath="/software-escrows" />;
};

const SummaryPage = () => {
  const {
    softwareEscrow: { id, agreement, beneficiary, depositor, currentCompanyRole, startedBy },
  } = useSoftwareEscrow();

  const isInvitedParty = currentCompanyRole !== startedBy;

  return (
    <SoftwareOnboardingMain
      title={
        isInvitedParty ? 'Check your details and submit the escrow for review' : 'We’re ready to set up your escrow!'
      }
      classes={{
        note: 'not-italic [&>span]:hidden',
      }}
      noteText={
        <Fragment>
          Review your selections to make sure everything looks good. We’ll use these settings to generate your escrow
          agreement.
          <br />
          When you click <strong>{isInvitedParty ? 'Submit' : 'Generate'}</strong>, your configuration will be sent to
          us for review.
        </Fragment>
      }
    >
      <div className="container mx-auto space-y-4">
        <BasicsCard />
        <Members />
        <PartyContextProvider
          type={EscrowPartyTypeEnum.Depositor}
          party={depositor}
          escrowId={id}
          agreementForm={agreement.agreementForm!}
          basePath="/software-escrows"
        >
          <PartyCard />
        </PartyContextProvider>
        <PartyContextProvider
          type={EscrowPartyTypeEnum.Beneficiary}
          party={beneficiary}
          escrowId={id}
          agreementForm={agreement.agreementForm!}
          basePath="/software-escrows"
        >
          <PartyCard />
        </PartyContextProvider>
        <TechnicalSettingsCard />
        <AgreementSettingsCard />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default SummaryPage;
